import { useTranslation } from 'react-i18next'

import { LightningSlashIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import ExchangeErrorResolutionSelector from './ExchangeErrorResolutionSelector/ExchangeErrorResolutionSelector'
import ExchangeOrdersAutomaticCreationSelector from './ExchangeOrdersAutomaticCreationSelector/ExchangeOrdersAutomaticCreationSelector'
import ExchangeSendProviderNotificationCheckbox from './ExchangeSendProviderNotificationCheckbox/ExchangeSendProviderNotificationCheckbox'
import IssueExchangeAtStatusSelector from './IssueExchangeAtStatusSelector/IssueExchangeAtStatusSelector'
import * as Styles from './styles'

const NormalExchangesConfiguration = ({
  allowExchanges,
  allowedExchangeMethods,
  allowedPreferences,
  exchangeOrdersAutomaticCreation,
  setExchangeOrdersAutomaticCreation,
  issueExchangeAtStatus,
  setIssueExchangeAtStatus,
  availableIssueExchangeStatus,
  exchangeErrorResolution,
  setExchangeErrorResolution,
  exchangeOrdersSendProviderNotification,
  setExchangeOrdersSendProviderNotification,
  provider,
  subscriptionPlan,
  disabled,
  exchangePaymentExpiration,
  setExchangePaymentExpiration,
}) => {
  const { t } = useTranslation()

  if (!allowedPreferences.includes(preferences.allowsExchanges) || !allowExchanges) return null

  return (
    <Styles.Container>
      <Styles.Title type="bodyMBold">
        <LightningSlashIcon size={24} />
        {t('Cambios estándar')}
      </Styles.Title>
      <Text type="bodyMRegular">
        {t('Los clientes podrán recibir cambios estándar tras devolver sus viejos productos (Sin cobertura Reveni)')}
      </Text>
      <ExchangeOrdersAutomaticCreationSelector
        allowedExchangeMethods={allowedExchangeMethods}
        allowedPreferences={allowedPreferences}
        exchangeOrdersAutomaticCreation={exchangeOrdersAutomaticCreation}
        setExchangeOrdersAutomaticCreation={setExchangeOrdersAutomaticCreation}
        disabled={disabled}
      />
      <IssueExchangeAtStatusSelector
        allowedExchangeMethods={allowedExchangeMethods}
        allowedPreferences={allowedPreferences}
        exchangeOrdersAutomaticCreation={exchangeOrdersAutomaticCreation}
        issueExchangeAtStatus={issueExchangeAtStatus}
        setIssueExchangeAtStatus={setIssueExchangeAtStatus}
        availableIssueExchangeStatus={availableIssueExchangeStatus}
        disabled={disabled}
        exchangePaymentExpiration={exchangePaymentExpiration}
        setExchangePaymentExpiration={setExchangePaymentExpiration}
      />
      <ExchangeErrorResolutionSelector
        value={exchangeErrorResolution}
        onChange={setExchangeErrorResolution}
        allowedExchangeMethods={allowedExchangeMethods}
        allowedPreferences={allowedPreferences}
        exchangeOrdersAutomaticCreation={exchangeOrdersAutomaticCreation}
        issueExchangeAtStatus={issueExchangeAtStatus}
        subscriptionPlan={subscriptionPlan}
        disabled={disabled}
      />
      <ExchangeSendProviderNotificationCheckbox
        checked={exchangeOrdersSendProviderNotification}
        onChange={setExchangeOrdersSendProviderNotification}
        allowedExchangeMethods={allowedExchangeMethods}
        allowedPreferences={allowedPreferences}
        exchangeOrdersAutomaticCreation={exchangeOrdersAutomaticCreation}
        provider={provider}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default NormalExchangesConfiguration
